// ============================================================================
// OBT (Operasyonel Bilgi Toplama) sekmesi — Faz F1 giriş noktası
// ============================================================================
// Mevcut kullanıcı paneli deseni izlenir: her özellik `components/tabs/*Tab`
// bileşenidir, ayrıntılar kardeş `components/obt/` klasöründedir
// (`components/mesai/` ile aynı yapı).
//
// Bu dosya bilinçli olarak incedir: yetki kapısı + kabuk. F2-F4 paketleri
// `components/obt/` altında paralel geliştirilebilsin diye burada iş mantığı
// tutulmaz.
// ============================================================================

import ObtAccessGuard from '@/components/obt/ObtAccessGuard';
import ObtShell from '@/components/obt/ObtShell';

export default function ObtTab() {
  return (
    <ObtAccessGuard>
      <ObtShell />
    </ObtAccessGuard>
  );
}
